import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ActiveCallRegisterType } from 'src/app/pages/active-calls/services/active-calls-register-session-storage.service';

@Directive()
export abstract class NavigatableDialog {
   @Input() totalCount: number;

   @Output() navigateUp = new EventEmitter<string | number>();
   @Output() navigateDown = new EventEmitter<string | number>();
   @Output() loadIdPage = new EventEmitter<void>();

   abstract get entityId(): number | string | null;
   abstract get allRelatedCallDetailIds(): number[];
   abstract get registerType(): ActiveCallRegisterType;

   get indexDisplay(): string {
      if (
         !this.entityId ||
         this.allRelatedCallDetailIds?.length <= 1 ||
         this.registerType !== ActiveCallRegisterType.AccountHistory
      ) {
         return '';
      }
      const index = this.allRelatedCallDetailIds.findIndex((id) => id === this.entityId);
      return index === -1 ? '' : `${index + 1} of ${this.allRelatedCallDetailIds.length}`;
   }

   get hasNavigateUp(): boolean {
      if (this.allRelatedCallDetailIds?.length === 1) return false;

      return (
         this.allRelatedCallDetailIds.findIndex((id) => id === this.entityId) < this.allRelatedCallDetailIds.length - 1
      );
   }

   get hasNavigateDown(): boolean {
      if (this.allRelatedCallDetailIds?.length === 1) return false;

      return this.allRelatedCallDetailIds.findIndex((id) => id === this.entityId) !== 0;
   }

   onNavigateUp() {
      const currentIndex = this.allRelatedCallDetailIds.findIndex((id) => id === this.entityId);
      this.navigateUp.emit(this.allRelatedCallDetailIds[currentIndex + 1]);
   }

   onNavigateDown() {
      const currentIndex = this.allRelatedCallDetailIds.findIndex((id) => id === this.entityId);
      this.navigateDown.emit(this.allRelatedCallDetailIds[currentIndex - 1]);
   }
}
